import { COLORS } from 'constants/design';
export const StyledCard = {
  backgroundColor: COLORS.LIGHT_ORANGE,
  padding: '8px 16px 8px 8px',
};
export const SpacingTopBottom = { padding: '20px 30px' };
export const StyledText = {
  color: COLORS.ORANGE_TEXT,
  fontSize: '14px',
  fontWeight: 500,
};
export const SpacingBottom = { padding: '0px 30px 10px 30px' };
